function reinitializeAddThisWithCopyLink(container, link, title, image, summary){
  if(container && link){
    var content_box = jQuery(container);
    var twitter_account = content_box.data("twitter-account");
    var text_copy_link = content_box.data("text-copy-link");
    var text_alert_copy_link = content_box.data("text-alert-copy-link");
    if(!title) title = "";
    if(!image) image = "";
    if(!summary) summary = "";
    content_box.empty();
    content_box.html('<div class="box-share addthis_toolbox addthis_default_style ">\
      <span class="st_fblike_hcount" st_title="'+title+'" st_url="'+link+'" displayText="fblike" st_image="'+image+'" st_summary="'+summary+'"></span>\
      <span st_via="'+twitter_account+'" class="st_twitter_hcount" st_title="'+title+'" st_url="'+link+'" displayText="twitter" st_image="'+image+'" st_summary="'+summary+'"></span>\
      <span class="st_plusone_hcount" st_title="'+title+'" st_url="'+link+'" displayText="Google +1" st_image="'+image+'" st_summary="'+summary+'"></span>\
      <span class="relative" style="height: 14px;"><span class="copy-button" data-url="'+link+'" data-text="'+text_alert_copy_link+'"><span><span class="big">+</span><span>'+text_copy_link+'</span></span></span></span>\
    </div>');
    if(window.addthis){
      window.addthis = null;
      window._adr = null;
      window._atc = null;
      window._atd = null;
      window._ate = null;
      window._atr = null;
      window._atw = null;
    }
    jQuery.getScript('https://s7.addthis.com/js/250/addthis_widget.js#domready=1');
    data_resize_and_center();
    data_center_image();
  }
}

function reinitializeAddThis(el, href, title){
  jQuery(el).empty();
  jQuery(el).html('<div class="addthis_toolbox addthis_default_style " addthis:url="'+href+'" addthis:title="'+title+'"><a class="addthis_button_facebook_like at300b" fb:like:layout="button_count" title="Facebook_like" href="#"></a><a class="addthis_button_tweet at300b" title="Tweet" href="#"></a><a class="addthis_button_google_plusone at300b" g:plusone:size="medium" title="Google_plusone" href="#"></a><a class="addthis_counter addthis_pill_style" style="display: block; " href="#"></a><div class="atclear"></div></div>');
  if(window.addthis){
    window.addthis = null;
    window._adr = null;
    window._atc = null;
    window._atd = null;
    window._ate = null;
    window._atr = null;
    window._atw = null;
  }
  jQuery.getScript('https://s7.addthis.com/js/250/addthis_widget.js#domready=1');
}

function refreshAddThis(){
  if(typeof stButtons !== "undefined" && typeof stButtons.locateElements === 'function')
    stButtons.locateElements();
  inizializeZclip();
  data_resize_and_center();
  data_center_image();
}

jQuery(document).ready(function(){
  var fbShare = jQuery(".addthis_toolbox .addthis_button_facebook_like");
  if(fbShare.length>0){
    setTimeout(function(){
      if(fbShare.first().html()==="")
        refreshAddThis();
    },3000);
  }
});

function old_inizializeZclip(){
  var copy_button = jQuery(".copy-button");
  if(copy_button.length > 0){
    copy_button.zclip({
      path: "/wp-content/themes/StartTheme3.0/zero_clipboard.swf",
      copy: function(){return jQuery(this).data().url},
      afterCopy: function(){alert(jQuery(this).data().text)}
    });
  }
}

function inizializeZclip(){
  var copy_button = jQuery(".copy-button");
  if(copy_button.length > 0){
    jQuery(".copy-button").addClass('clipboard');
    var clipboard = new ClipboardJS('.copy-button', {
      text: function(trigger){
        return trigger.getAttribute('data-url');
      }
    });
    clipboard.on('success', function(e){
      alert(e.trigger.getAttribute('data-text'));
    });
  }
}